module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr15-ded875aaf728d736b203022faa195ccd.jpg";